import { useCallback } from 'react';
import { Category, Product } from 'shared/types/product';
import { ProductQuery } from 'shared/types/query/ProductQuery';
import { CategoryPaginatedResult } from 'shared/types/result/PaginatedResult';
import useSWR from 'swr';
import { sdk } from 'sdk';

const useProduct = ({ query, limit }: Partial<ProductQuery> = {}) => {
  const { data: productsData, isLoading } = useSWR(['/action/product/query', query, limit], () =>
    sdk.composableCommerce.product.query({ query, limit }),
  );

  const products = (productsData?.isError ? [] : (productsData?.data?.items as Product[])) ?? [];

  const { data: categoriesData } = useSWR('/action/product/queryCategories?hideEmpty=true', () =>
    sdk.callAction<CategoryPaginatedResult>({
      actionName: 'product/queryCategories',
      query: { format: 'tree', hideEmpty: true },
    }),
  );

  const categories = (categoriesData?.isError ? [] : (categoriesData?.data?.items as Category[])) ?? [];

  const queryProducts = useCallback(async (productQuery: ProductQuery) => {
    const extensions = sdk.composableCommerce;

    const res = await extensions.product.query(productQuery);

    return res;
  }, []);

  return { products, isProductSearchLoading: isLoading, categories, query: queryProducts };
};

export default useProduct;
